/**
 * VideoUploadPrivacyNotice component
 *
 * Explains how uploaded video content and personal data are stored, with links out to the
 * Privacy Policy.
 */
export const VideoUploadPrivacyNotice = () => {
  /* Render */
  return (
    <div className="bg-base-200 rounded-2xl px-4 py-4 mt-auto shrink-0">
      <p className="text-sm">
        By uploading content you agree to our{" "}
        <a href="#" className="underline">
          Privacy Policy
        </a>
        . Personal information and video data will be stored by Dragonfly AI to ensure we can provide services to you.
        <br />
        You can find more information on how to ensure compliance with any applicable privacy laws when uploading content in{" "}
        <a href="#" className="underline">
          Privacy Policy
        </a>
        .
      </p>
    </div>
  );
};
